import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@ui/store';

import { getQuoteBuilderOrThrow } from '../utilities/selector-guards';

export const selectQuoteBuilder = (state: RootState) =>
  getQuoteBuilderOrThrow(state.quoteBuilder);

/**
 * Every week length a lead time calculation needs. The quantity-aware strategy
 * converts each of its terms on its own week, so they travel together.
 */
export const selectLeadTimeSiteConfig = createSelector(
  [
    (state: RootState) => selectQuoteBuilder(state).productionDaysPerWeek,
    (state: RootState) => selectQuoteBuilder(state).transitDaysPerWeek,
    (state: RootState) => selectQuoteBuilder(state).planningDaysPerWeek,
  ],
  (productionDaysPerWeek, transitDaysPerWeek, planningDaysPerWeek) => ({
    productionDaysPerWeek,
    transitDaysPerWeek,
    planningDaysPerWeek,
  }),
);
